import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {CategoryInfoDto} from "../modal-category/DTO/category-info.dto";

@Injectable({
  providedIn: 'root'
})
export class ModalCategoryService {

  constructor(private http : HttpClient) { }

  apiSearch = environment.apiSearch
  apiDetail = environment.apiDetail
  apiGetChildren = environment.apiGetChildren
  getApiSearch(keyword) {
    // @ts-ignore
    return this.http.get<CategoryInfoDto[]>(`${this.apiSearch}`, { params: {keyword, pageSize: 200}})
  }
  getApiDetail(id) {
    return  this.http.get(`${this.apiDetail}/${id}`)
  }

  getChildrenById (id) {
    return this.http.get(`${this.apiGetChildren}/${id}`)
  }
}
